// extracted by mini-css-extract-plugin
module.exports = {"platform":"page_platform__hqVlY"};